import { createFileRoute } from "@tanstack/react-router"
import { ProfileTab } from "./_profile-tab"

export const Route = createFileRoute("/settings/profile")({
  component: ProfileTab,
})
